const translation = {
  common: {
    welcome: '',
    appUnavailable: 'アプリケーションは利用できません',
    appUnknownError: 'アプリケーションは利用できません',
  },
  chat: {
    newChat: '新規チャット',
    newChatTip: '新規チャットが開始されています',
    chatSettingsTitle: 'チャット設定',
    chatFormTip: 'チャット開始後は設定を変更できません',
    pinnedTitle: 'ピン留め済み',
    unpinnedTitle: 'チャットリスト',
    newChatDefaultName: '新規チャット',
    resetChat: 'チャットをリセット',
    viewChatSettings: '設定を確認',
    poweredBy: 'Powered by',
    prompt: 'プロンプト',
    privatePromptConfigTitle: '個別設定',
    publicPromptConfigTitle: '共通プロンプト設定',
    configStatusDes: '開始前に設定を変更できます',
    configDisabled: '前回の設定を適用中です',
    startChat: 'チャットを開始',
    privacyPolicyLeft: '本アプリの',
    privacyPolicyMiddle: 'プライバシーポリシー',
    privacyPolicyRight: 'に同意の上ご利用ください',
    deleteConversation: {
      title: 'チャットの削除',
      content: 'このチャットを削除しますか？',
    },
    tryToSolve: '問題を解決する',
    temporarySystemIssue: 'システムに一時的な問題が発生しています',
    expand: '拡大',
    collapse: '縮小',
  },
  generation: {
    tabs: {
      create: '1 回実行',
      batch: '一括実行',
      saved: '保存済み',
    },
    savedNoData: {
      title: '保存済みデータがありません',
      description: 'コンテンツ生成後に結果がここに表示されます',
      startCreateContent: '生成を開始',
    },
    title: 'AI 文章作成',
    queryTitle: '入力内容',
    completionResult: '生成結果',
    queryPlaceholder: '入力してください',
    run: '実行',
    execution: '処理中',
    executions: '{{num}}回実行',
    copy: 'コピー',
    resultTitle: 'AI 生成結果',
    noData: 'AI がコンテンツを生成します',
    csvUploadTitle: 'CSV ファイルをドロップするか',
    browse: 'ファイルを選択',
    csvStructureTitle: 'CSV 形式要件：',
    downloadTemplate: 'テンプレートを取得',
    field: '',
    batchFailed: {
      info: '{{num}}件の失敗',
      retry: '再実行',
      outputPlaceholder: '出力なし',
    },
    errorMsg: {
      empty: 'ファイル内容が空です',
      fileStructNotMatch: 'ファイル形式が不正です',
      emptyLine: '{{rowIndex}}行目：内容が空です',
      invalidLine: '{{rowIndex}}行目：{{varName}}の入力が必要です',
      moreThanMaxLengthLine: '{{rowIndex}}行目：{{varName}}が制限長（{{maxLength}}）を超過',
      atLeastOne: '1 行以上のデータが必要です',
    },
  },
  login: {
    backToHome: 'ホームに戻る',
  },
}

export default translation
